/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { clearCustomCohortList } from "src/redux/features/custom-cohorts/customCohortsSlice";

import {
  initialState,
  setShowModal,
} from "src/redux/features/charts/modalSlice";

/* Ionic */
import {
  chevronBack,
  chevronForward,
  trash,
  close,
} from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./ListToolbar.module.scss";

/* Interfaces */
interface ToolbarProps {
  showCohortList: boolean;
  setShowCohortList: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const ListToolbar: React.FC<ToolbarProps> = ({
  showCohortList,
  setShowCohortList,
}) => {
  const dispatch = useDispatch();

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const { currentDiseaseId, customCohortsByDisease } =
    customCohortsState;

  const cohorts = currentDiseaseId
    ? customCohortsByDisease[currentDiseaseId]?.cohorts ??
      []
    : [];

  const disabled = cohorts.length === 0;

  return (
    <div
      style={{
        padding: showCohortList
          ? "0px 16px 0px 52px"
          : "0px",
        justifyContent: !showCohortList
          ? "center"
          : undefined,
      }}
      className={styles.list_toolbar}
    >
      <PrimaryFabButton
        scssProps={{
          marginRight: showCohortList ? "auto" : undefined,
          color: "var(--ion-color-text-tertiary)",
          background: "transparent",
        }}
        className={"small"}
        ariaLabel={"collapse"}
        icon={showCohortList ? chevronForward : chevronBack}
        disabled={false}
        onClick={() => {
          setShowCohortList((prev: boolean) => !prev);
        }}
      />
      {showCohortList ? (
        <div className={styles.flex_container}>
          <PrimaryFabButton
            scssProps={{
              color: disabled
                ? "var(--ion-color-text-disabled)"
                : "var(--ion-color-text-tertiary)",
              background: "transparent",
            }}
            className={"small"}
            ariaLabel={"trash"}
            icon={trash}
            disabled={disabled}
            onClick={() => {
              dispatch(clearCustomCohortList());
            }}
          />
          <PrimaryFabButton
            className={"small"}
            ariaLabel={"Close"}
            icon={close}
            onClick={() => {
              dispatch(setShowModal(initialState));
            }}
            scssProps={{
              background: "transparent",
              color: "var(--ion-color-text-tertiary)",
            }}
          />
        </div>
      ) : undefined}
    </div>
  );
};

export default ListToolbar;
